var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner-container",style:({height: `${_vm.height || 500}px`})},[_c('div',{staticClass:"spinner"}),(_vm.message)?_c('span',{staticClass:"message"},[_vm._v(_vm._s(_vm.message))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }